import styled from 'styled-components'

const Icon = styled.span<{ autoSize?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  vertical-align: middle;

  svg {
    width: 1em;
    height: 1em;

    ${(props) =>
      props.autoSize &&
      `
      width: 100%;
      height: auto;
    `}
  }
`

const icons = {
  logo: (
    <svg viewBox="0 0 381 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m26.23 21.92-4.614 2.734c-.863-1.497-1.685-2.474-2.466-2.93-.814-.52-1.864-.78-3.15-.78-1.578 0-2.888.447-3.93 1.342-1.042.879-1.563 1.986-1.563 3.32 0 1.84 1.368 3.32 4.102 4.444l3.76 1.538c3.06 1.237 5.298 2.75 6.714 4.54 1.416 1.775 2.124 3.956 2.124 6.544 0 3.467-1.156 6.331-3.467 8.594-2.328 2.278-5.217 3.418-8.667 3.418-3.272 0-5.973-.969-8.106-2.906-2.1-1.936-3.41-4.663-3.93-8.178l5.761-1.27c.26 2.214.717 3.744 1.368 4.59 1.171 1.627 2.88 2.441 5.127 2.441 1.774 0 3.247-.594 4.419-1.782 1.171-1.188 1.757-2.694 1.757-4.517 0-.732-.106-1.4-.317-2.002a4.696 4.696 0 0 0-.952-1.684c-.423-.52-.977-1.001-1.66-1.44-.684-.456-1.498-.888-2.442-1.294l-3.637-1.514c-5.16-2.181-7.74-5.371-7.74-9.57 0-2.832 1.083-5.2 3.247-7.105 2.165-1.92 4.859-2.88 8.081-2.88 4.346 0 7.74 2.115 10.181 6.347ZM35.825 16.305 45.639 41.5l10.254-27.026L65.708 41.5l10.424-25.195h6.177L65.463 56.393l-9.692-26.71-10.107 26.734-16.016-40.112h6.177ZM92.685 16.305V54h-5.688V16.305h5.688ZM112.143 21.651V54h-5.688V21.651h-8.667v-5.346h22.998v5.346h-8.643ZM152.353 18.331v6.738c-3.288-2.75-6.689-4.126-10.205-4.126-3.874 0-7.137 1.392-9.79 4.175-2.669 2.767-4.004 6.152-4.004 10.156 0 3.956 1.335 7.292 4.004 10.01 2.669 2.718 5.941 4.077 9.814 4.077 2.002 0 3.703-.325 5.103-.976a14.323 14.323 0 0 0 2.417-1.319 27.812 27.812 0 0 0 2.661-2.002v6.86c-3.255 1.84-6.673 2.76-10.254 2.76-5.387 0-9.985-1.88-13.794-5.64-3.792-3.792-5.688-8.366-5.688-13.72 0-4.802 1.587-9.083 4.761-12.843 3.906-4.606 8.959-6.909 15.161-6.909 3.385 0 6.657.92 9.814 2.76ZM166.318 31.05h16.26V16.306h5.688V54h-5.688V36.398h-16.26V54h-5.689V16.305h5.689V31.05ZM197.299 54V16.305h5.664c2.523 0 4.533.195 6.031.586 1.513.39 2.791 1.05 3.833 1.977 1.058.96 1.896 2.157 2.514 3.589.635 1.449.953 2.913.953 4.395 0 2.701-1.034 4.988-3.101 6.86 2.002.683 3.581 1.88 4.736 3.589 1.172 1.692 1.758 3.662 1.758 5.908 0 2.946-1.042 5.436-3.125 7.47-1.253 1.254-2.661 2.125-4.224 2.613-1.709.472-3.849.708-6.42.708h-8.619Zm5.689-21.509h1.782c2.116 0 3.662-.464 4.639-1.391.993-.944 1.489-2.328 1.489-4.15 0-1.775-.505-3.118-1.514-4.03-1.009-.927-2.474-1.39-4.394-1.39h-2.002V32.49Zm0 16.162h3.516c2.571 0 4.459-.504 5.664-1.513 1.269-1.09 1.904-2.474 1.904-4.15 0-1.628-.61-2.995-1.831-4.102-1.188-1.09-3.312-1.636-6.372-1.636h-2.881v11.401ZM224.716 34.981c0-5.306 1.945-9.863 5.835-13.671 3.874-3.809 8.529-5.713 13.965-5.713 5.371 0 9.977 1.92 13.819 5.761 3.857 3.841 5.786 8.456 5.786 13.843 0 5.42-1.937 10.018-5.811 13.794-3.89 3.792-8.585 5.689-14.087 5.689-4.866 0-9.236-1.685-13.11-5.054-4.264-3.727-6.397-8.61-6.397-14.649Zm5.738.074c0 4.166 1.399 7.593 4.199 10.278 2.783 2.686 5.998 4.028 9.643 4.028 3.956 0 7.292-1.367 10.01-4.101 2.718-2.767 4.077-6.136 4.077-10.108 0-4.02-1.342-7.389-4.028-10.107-2.669-2.735-5.973-4.102-9.912-4.102-3.923 0-7.235 1.367-9.937 4.102-2.701 2.702-4.052 6.038-4.052 10.01ZM291.513 44.845h-16.137l-4.2 9.155h-6.128l18.653-40.063L301.694 54h-6.226l-3.955-9.155Zm-2.319-5.347-5.591-12.817-5.859 12.817h11.45ZM319.199 37.935 330.869 54h-6.958l-10.767-15.43h-1.025V54h-5.689V16.305h6.665c4.981 0 8.578.936 10.791 2.807 2.442 2.084 3.662 4.834 3.662 8.252 0 2.67-.765 4.964-2.294 6.885-1.53 1.92-3.549 3.15-6.055 3.686Zm-7.08-4.32h1.806c5.388 0 8.081-2.06 8.081-6.178 0-3.857-2.62-5.786-7.861-5.786h-2.026v11.963ZM336.557 54V16.305h7.91c3.793 0 6.787.374 8.985 1.123 2.36.732 4.5 1.977 6.421 3.735 3.89 3.548 5.835 8.211 5.835 13.99 0 5.794-2.027 10.481-6.079 14.062-2.035 1.79-4.167 3.035-6.397 3.735-2.083.7-5.037 1.05-8.862 1.05h-7.813Zm5.689-5.347h2.563c2.556 0 4.68-.268 6.372-.805a12.93 12.93 0 0 0 4.59-2.71c2.8-2.556 4.199-5.884 4.199-9.986 0-4.134-1.383-7.487-4.15-10.058-2.49-2.295-6.161-3.443-11.011-3.443h-2.563v27.002Z"
        fill="currentColor"
      />
    </svg>
  ),
  'logo-short': (
    <svg viewBox="0 0 66 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m28.13 21.92-4.614 2.734c-.863-1.497-1.685-2.474-2.466-2.93-.814-.52-1.864-.78-3.15-.78-1.578 0-2.888.447-3.93 1.342-1.042.879-1.563 1.986-1.563 3.32 0 1.84 1.368 3.32 4.102 4.444l3.76 1.538c3.06 1.237 5.298 2.75 6.714 4.54 1.416 1.775 2.124 3.956 2.124 6.544 0 3.467-1.156 6.331-3.467 8.594-2.328 2.278-5.217 3.418-8.667 3.418-3.272 0-5.973-.969-8.106-2.906-2.1-1.936-3.41-4.663-3.93-8.178l5.761-1.27c.26 2.214.717 3.744 1.368 4.59 1.171 1.627 2.88 2.441 5.127 2.441 1.774 0 3.247-.594 4.418-1.782 1.172-1.188 1.758-2.694 1.758-4.517 0-.732-.105-1.4-.317-2.002a4.697 4.697 0 0 0-.952-1.684c-.423-.52-.977-1.001-1.66-1.44-.684-.456-1.498-.888-2.442-1.294l-3.638-1.514c-5.159-2.181-7.739-5.371-7.739-9.57 0-2.832 1.083-5.2 3.247-7.105 2.165-1.92 4.859-2.88 8.081-2.88 4.346 0 7.74 2.115 10.181 6.347ZM35.967 54V16.305h5.664c2.523 0 4.533.195 6.03.586 1.514.39 2.792 1.05 3.833 1.977 1.058.96 1.897 2.157 2.515 3.589.635 1.449.952 2.913.952 4.395 0 2.701-1.033 4.988-3.1 6.86 2.002.683 3.58 1.88 4.736 3.589 1.172 1.692 1.758 3.662 1.758 5.908 0 2.946-1.042 5.436-3.125 7.47-1.254 1.254-2.661 2.125-4.224 2.613-1.709.472-3.85.708-6.42.708h-8.619Zm5.689-21.509h1.782c2.116 0 3.662-.464 4.638-1.391.993-.944 1.49-2.328 1.49-4.15 0-1.775-.505-3.118-1.514-4.03-1.01-.927-2.474-1.39-4.395-1.39h-2.001V32.49Zm0 16.162h3.515c2.572 0 4.46-.504 5.664-1.513 1.27-1.09 1.904-2.474 1.904-4.15 0-1.628-.61-2.995-1.83-4.102-1.189-1.09-3.313-1.636-6.373-1.636h-2.88v11.401Z"
        fill="currentColor"
      />
    </svg>
  ),
  account: (
    <svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11a3.432 3.432 0 1 0 0-6.863A3.432 3.432 0 0 0 10 11Zm-6.661 6.677h13.306s.298-1.39 0-2.193c-.355-.956-1.032-1.312-1.875-1.757-.137-.072-.28-.147-.425-.227-1.501-.825-4.3-.863-4.3-.863s-2.828.04-4.353.863c-.16.086-.314.165-.464.242-.847.434-1.532.785-1.89 1.742-.299.802 0 2.193 0 2.193Z"
        fill="currentColor"
      />
    </svg>
  ),
  checkmark: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m8.8 15.9-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4L8.8 15.9Z"
        fill="currentColor"
      />
    </svg>
  ),
  hamburger: (
    <svg
      viewBox="0 0 32 32"
      aria-labelledby="Hamburger"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor" stroke="currentColor" stroke-width="1">
        <path d="M1 7h30a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2z"></path>
        <path d="M31 15H1a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2z"></path>
        <path d="M31 25H1a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2z"></path>
      </g>
    </svg>
  ),
  close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="Close"
      viewBox="0 0 24 24"
    >
      <path
        d="M1.922.508L.508 1.922l10.08 10.08L.512 22.078l1.414 1.414 10.076-10.076 10.07 10.07 1.414-1.414-10.07-10.07L23.492 1.926 22.078.512 12.002 10.588 1.922.508z"
        fill="currentColor"
        fill-rule="evenodd"
        stroke="currentColor"
        stroke-width="0.5"
      ></path>
    </svg>
  ),
}

export type IconNameType = keyof typeof icons

type PropsType = {
  icon: IconNameType
  className?: string
  autoSize?: boolean
  onClick?: () => void
  style?: React.CSSProperties
}

const InlineSVG = ({
  icon,
  autoSize,
  onClick,
  style,
  className,
}: PropsType) => (
  <Icon
    className={className}
    onClick={onClick}
    style={{ ...style }}
    autoSize={autoSize}
  >
    {icons[icon]}
  </Icon>
)

export default InlineSVG
